import React from 'react'
import { CUSTOMER_MODALS } from '../Customers/customers.constants'
import DeleteUserModal from './DeleteUserModal'
import ResetUserModal from './ResetUserModal'
import EditAssignmentModal from './EditAssignmentModal'
import VarianceDataModal from './VarianceDataModal'
import DeleteAccountModal from './DeleteAccountModal'
import SwitchAccountTypeModal from './SwitchAccountTypeModal'

const getCustomersModal = (modalName) => {
	switch (modalName) {
		case CUSTOMER_MODALS.RESET_CUSTOMER_USER_PASSWORD:
			return <ResetUserModal />
		case CUSTOMER_MODALS.DELETE_USER_MODAL:
			return <DeleteUserModal />
		case CUSTOMER_MODALS.EDIT_ASSIGNMENT_MODAL:
			return <EditAssignmentModal />
		case CUSTOMER_MODALS.SWITCH_ACCOUNT_TYPE_MODAL:
			return <SwitchAccountTypeModal />
		case CUSTOMER_MODALS.VARIANCE_DATA_MODAL:
			return <VarianceDataModal />
		case CUSTOMER_MODALS.DELETE_DUPLICATE_ACCOUNT_MODAL:
			return <DeleteAccountModal />
		default:
			return null
	}
}

export default getCustomersModal
